var labels = {
  dataplex: {
    nivel: 2,
    scope_closed_hint: {
      es: '(Última Semana, Últimos 15 dias, Último Mes, Últimos 6 meses)',
      en: '(Last Week, Last 15 days, Last Month, Last 6 months)'
    },
    scope_closed_label: {
      es: '¿Fecha Cerrada?',
      en: '¿Closed Date?'
    },
    rules: {
      nivel: 3,
      title: {
        es: 'Reglas de Calidad',
        en: 'Quality Rules'
      },
      description: {
        es: 'Reglas de calidad de datos para la validación de columnas.',
        en: 'Data quality rules for column validation.'
      },
      create_rule: {
        es: 'Crear Regla',
        en: 'Create Rule'
      },
      update_rule: {
        es: 'Actualizar Regla',
        en: 'Update Rule'
      },
      view_rule: {
        es: 'Ver Regla',
        en: 'View Rule'
      },
      fields: {
        nivel: 4,
        name: {
          es: 'Nombre',
          en: 'Name'
        },
        description: {
          es: 'Descripción',
          en: 'Description'
        },
        dimension: {
          es: 'Dimensión',
          en: 'Dimension'
        },
        validation: {
          es: 'Validación',
          en: 'Validation'
        },
        values: {
          es: 'Valores',
          en: 'Values'
        },
        min: {
          es: 'Mínimo',
          en: 'Min'
        },
        max: {
          es: 'Máximo',
          en: 'Max'
        },
        strict: {
          es: 'Estrictamente',
          en: 'Strict'
        },
        ignore_null: {
          es: 'Ignorar Nulos (Valores de: Rango, Regex, Conjunto, únicos)',
          en: 'Ignore Null (Values: Range, Regex, Set, Uniqueness)'
        },
        threashold: {
          es: 'Umbral',
          en: 'Threashold'
        },
        range_statistic: {
          es: 'Rango Estadístico',
          en: 'Statistic Range'
        },
        actions: {
          es: 'Acciones',
          en: 'Actions'
        }
      }
    },
    profiling: {
      nivel: 3,
      title: {
        es: 'Perfilamiento',
        en: 'Profiling'
      },
      description: {
        es: 'Analiza los datos en tablas y genera información sobre la estructura, el contenido y las relaciones (como porcentaje nulo, cardinalidad, mínimo/máximo/media, etc.).',
        en: 'Analyzes data in tables and generates information about structure, content, and relationships (such as null percentage, cardinality, min/max/mean, etc.).'
      },
      tab_general: {
        es: 'Datos Generales',
        en: 'Metadata'
      },
      tab_execution: {
        es: 'Ejecuciones',
        en: 'Executions'
      },
      tab_detail_execution: {
        es: 'Detalle Ejecución',
        en: 'Execution Detail'
      },
      create_profiling: {
        es: 'Crear Perfilamiento',
        en: 'Create Profiling'
      },
      update_profiling: {
        es: 'Actualizar Perfilamiento',
        en: 'Update Profiling'
      },
      view_profiling: {
        es: 'Ver Perfilamiento',
        en: 'View Profiling'
      },
      fields: {
        nivel: 4,
        name: {
          es: 'Nombre',
          en: 'Name'
        },
        description: {
          es: 'Descripción',
          en: 'Description'
        },
        table: {
          es: 'Tabla',
          en: 'Table'
        },
        last_execution: {
          es: 'Última Ejecución',
          en: 'Last Execution'
        },
        state: {
          es: 'Estado',
          en: 'State'
        },
        actions: {
          es: 'Acciones',
          en: 'Actions'
        },
        sample_size: {
          es: 'Tamaño de Muestra',
          en: 'Sample Size'
        },
        row_filter: {
          es: 'Filtrar Filas',
          en: 'Row Filter'
        },
        columns_included: {
          es: 'Incluir Columnas',
          en: 'Columns Included'
        },
        columns_excluded: {
          es: 'Excluir Columnas',
          en: 'Columns Excluded'
        },
        scope: {
          es: 'Alcance',
          en: 'Scope'
        },
        scope_complete: {
          es: 'Datos Completos',
          en: 'All Data'
        },
        scope_incremental: {
          es: 'Incremental',
          en: 'Incremental'
        },
        scope_period: {
          es: 'Periodo Incremental',
          en: 'Scope Period'
        },
        scope_column: {
          es: 'Columna de Tiempo',
          en: 'Time Column'
        },
        schedule_execution: {
          es: 'Programar Ejecución',
          en: 'Schedule Execution'
        },
        schedule_unique: {
          es: 'Ejecución única',
          en: 'Unique execution'
        },
        schedule_cron: {
          es: 'Ejecución Programada',
          en: 'Scheduled execution'
        },
        schedule_period: {
          es: 'Periodo de Ejecución',
          en: 'Execution Period'
        },
        schedule_day: {
          es: 'Dia de Ejecución',
          en: 'Execution Day'
        },
        schedule_hour: {
          es: 'Hora de Ejecución',
          en: 'Execution Hour'
        },
        schedule_column: {
          es: 'Columna de Tiempo',
          en: 'Time Column'
        },
        date_from: {
          es: 'Fecha Inicio',
          en: 'Date From'
        },
        date_till: {
          es: 'Fecha Fin',
          en: 'Date Until'
        },
        result: {
          es: 'Resultados',
          en: 'Result'
        },
        notification: {
          es: 'Notificar a (email):',
          en: 'Notify to (email):'
        },
        table_last_modification: {
          es: 'Fecha Última Modificación (Tabla)',
          en: 'Last Modified Time (Table)'
        }
      },
      execution_field: {
        nivel: 4,
        state: {
          es: 'Estado',
          en: 'State'
        },
        date_init: {
          es: 'Fecha Inicio',
          en: 'Date Init'
        },
        date_end: {
          es: 'Fecha Fin',
          en: 'Date End'
        },
        actions: {
          es: 'Acciones',
          en: 'Actions'
        },
        column: {
          es: 'Columna',
          en: 'Column'
        },
        result: {
          es: 'Resultados',
          en: 'Result'
        },
        type: {
          es: 'Tipo',
          en: 'Type'
        },
        null_ratio: {
          es: 'Porcentaje Nulo',
          en: 'Null Percentage'
        },
        distinct_ratio: {
          es: 'Porcentaje Único',
          en: 'Distinct Percentage'
        },
        statistic: {
          es: 'Estadísticas',
          en: 'Statistics'
        },
        values_10: {
          es: '10 Valores Principales',
          en: '10 Principal Values'
        }
      }
    },
    summary: {
      nivel: 3,
      title: {
        es: 'Resumen de Perfilamientos',
        en: 'Profiling Summary'
      },
      description: {
        es: 'Resumen del estado de los perfilamientos: última y próxima ejecución por tabla, y columnas cuyo porcentaje de valores nulos supera el umbral.',
        en: 'Profiling status summary: last and next execution per table, and columns whose null percentage exceeds the threshold.'
      },
      threshold: {
        es: 'Umbral de nulos',
        en: 'Null threshold'
      },
      download: {
        es: 'Descargar reporte',
        en: 'Download report'
      },
      columns_detail: {
        es: 'Columnas sobre el umbral (% de nulos)',
        en: 'Columns over threshold (% nulls)'
      },
      no_columns: {
        es: 'Ninguna columna supera el umbral.',
        en: 'No column exceeds the threshold.'
      },
      fields: {
        nivel: 4,
        table: {
          es: 'Tabla',
          en: 'Table'
        },
        last_execution: {
          es: 'Última Ejecución',
          en: 'Last Execution'
        },
        next_execution: {
          es: 'Próxima Ejecución',
          en: 'Next Execution'
        },
        columns_over: {
          es: 'Columnas sobre umbral',
          en: 'Columns over threshold'
        }
      }
    },
    quality: {
      nivel: 3,
      title: {
        es: 'Calidad de Datos',
        en: 'Data Quality'
      },
      description: {
        es: 'Genera consultas basadas en las reglas y las compara con los datos para obtener resultados de control de calidad de los datos.',
        en: 'Generates queries based on the rules and compares them with the data to obtain data quality control results.'
      },
      tab_general: {
        es: 'Datos Generales',
        en: 'Metadata'
      },
      tab_columns: {
        es: 'Columnas',
        en: 'Columns'
      },
      tab_execution: {
        es: 'Ejecuciones',
        en: 'Executions'
      },
      tab_detail_execution: {
        es: 'Detalle Ejecución',
        en: 'Execution Detail'
      },
      create_quality: {
        es: 'Registrar Análisis de Calidad de Datos',
        en: 'Register Data Quality Analysis'
      },
      update_quality: {
        es: 'Actualizar Análisis de Calidad de Datos',
        en: 'Update Data Quality Analysis'
      },
      view_quality: {
        es: 'Ver Análisis de Calidad de Datos',
        en: 'View Data Quality Analysis'
      },
      fields: {
        nivel: 4,
        name: {
          es: 'Nombre',
          en: 'Name'
        },
        description: {
          es: 'Descripción',
          en: 'Description'
        },
        table: {
          es: 'Tabla',
          en: 'Table'
        },
        last_execution: {
          es: 'Última Ejecución',
          en: 'Last Execution'
        },
        state: {
          es: 'Estado',
          en: 'State'
        },
        actions: {
          es: 'Acciones',
          en: 'Actions'
        },
        sample_size: {
          es: 'Tamaño de Muestra',
          en: 'Sample Size'
        },
        row_filter: {
          es: 'Filtrar Filas',
          en: 'Row Filter'
        },
        scope: {
          es: 'Alcance',
          en: 'Scope'
        },
        scope_complete: {
          es: 'Datos Completos',
          en: 'All Data'
        },
        scope_incremental: {
          es: 'Incremental',
          en: 'Incremental'
        },
        scope_period: {
          es: 'Periodo Incremental',
          en: 'Scope Period'
        },
        scope_column: {
          es: 'Columna de Tiempo',
          en: 'Time Column'
        },
        schedule_execution: {
          es: 'Programar Ejecución',
          en: 'Schedule Execution'
        },
        schedule_unique: {
          es: 'Ejecución única',
          en: 'Unique execution'
        },
        schedule_cron: {
          es: 'Ejecución Programada',
          en: 'Scheduled execution'
        },
        schedule_period: {
          es: 'Periodo de Ejecución',
          en: 'Execution Period'
        },
        schedule_day: {
          es: 'Dia de Ejecución',
          en: 'Execution Day'
        },
        schedule_hour: {
          es: 'Hora de Ejecución',
          en: 'Execution Hour'
        },
        schedule_column: {
          es: 'Columna de Tiempo',
          en: 'Time Column'
        },
        date_from: {
          es: 'Fecha Inicio',
          en: 'Date From'
        },
        date_till: {
          es: 'Fecha Fin',
          en: 'Date Until'
        },
        result: {
          es: 'Resultados',
          en: 'Result'
        },
        notification: {
          es: 'Notificación',
          en: 'Notification'
        },
        table_last_modification: {
          es: 'Fecha Última Modificación (Tabla)',
          en: 'Last Modified Time (Table)'
        }
      },
      column_field: {
        nivel: 4,
        column: {
          es: 'Columna',
          en: 'Column'
        },
        rule: {
          es: 'Regla',
          en: 'Rule'
        },
        rule_type: {
          es: 'Tipo de Regla',
          en: 'Rule Type'
        },
        dimension: {
          es: 'Dimensión',
          en: 'Dimension'
        },
        parameters: {
          es: 'Parámetros',
          en: 'Parameters'
        },
        threashold: {
          es: 'Umbral',
          en: 'Threashold'
        },
        actions: {
          es: 'Acciones',
          en: 'Actions'
        },
        add_column: {
          es: 'Agregar Columna - Regla',
          en: 'Add Column - Rule'
        },
        update_column: {
          es: 'Actualizar Columna - Regla',
          en: 'Update Column - Rule'
        },
        view_column: {
          es: 'Ver Columna - Regla',
          en: 'View Column Rule'
        },
        select_column: {
          es: 'Seleccionar Columna',
          en: 'Select Column'
        },
        select_rule: {
          es: 'Seleccionar Regla',
          en: 'Select Rule'
        },
        rule_detail: {
          es: 'Detalle de Regla',
          en: 'Rule Detail'
        }
      },
      execution_field: {
        nivel: 4,
        state: {
          es: 'Estado',
          en: 'State'
        },
        date_init: {
          es: 'Fecha Inicio',
          en: 'Date Init'
        },
        date_end: {
          es: 'Fecha Fin',
          en: 'Date End'
        },
        actions: {
          es: 'Acciones',
          en: 'Actions'
        },
        column: {
          es: 'Columna',
          en: 'Column'
        },
        result: {
          es: 'Resultados',
          en: 'Result'
        }
      },
      execution_detail: {
        nivel: 4,
        title: {
          es: 'Detalle Ejecución',
          en: 'Detail Execution'
        },
        column: {
          es: 'Columna',
          en: 'Column'
        },
        rule: {
          es: 'Regla',
          en: 'Rule'
        },
        state: {
          es: 'Estado',
          en: 'State'
        },
        validation: {
          es: 'Validación',
          en: 'Validation'
        },
        dimension: {
          es: 'Dimensión',
          en: 'Dimension'
        },
        parameters: {
          es: 'Parámetros',
          en: 'Parameters'
        },
        row_errors: {
          es: 'Filas con Errores',
          en: 'Row Errors'
        },
        threashold: {
          es: 'Umbral',
          en: 'Threashold'
        }
      }
    }
  },
  p_validation_type: {
    es: 'Tipos de validación de perfilamiento',
    en: 'Profiling validation type'
  },
  profiling_history: {
    es: 'Historial de perfilamiento',
    en: 'Profiling history'
  },
  score_params: {
    es: 'Parámetros de puntuación de perfilamiento',
    en: 'Profiling score parameters'
  },
  profiling_dashboard: {
    es: 'Tablero de perfilamiento',
    en: 'Profiling dashboard'
  },
  subtitle_p_validation_type: {
    es: '',
    en: ''
  },
  subtitle_profiling_history: {
    es: '',
    en: ''
  },
  subtitle_score_params: {
    es: '',
    en: ''
  },
  subtitle_profiling_dashboard: {
    es: '',
    en: ''
  },
  modals: {
    nivel: 2,
    general: {
      es: 'General',
      en: 'General'
    },
    columns: {
      es: 'Columnas',
      en: 'Columns'
    },
    bterm: {
      es: 'Término de negocio',
      en: 'Business term'
    },
    profiling: {
      es: 'Perfilamiento',
      en: 'Profiling'
    },
    lineage: {
      es: 'Linaje',
      en: 'Lineage'
    },
    hlogs: {
      es: 'Historial de registros',
      en: 'History logs'
    },
    organization: {
      es: 'Organización',
      en: 'Organization'
    },
    official_source: {
      es: 'Fuente oficial',
      en: 'Official source'
    },
    environment: {
      es: 'Entorno',
      en: 'Environment'
    },
    domain: {
      es: 'Dominio',
      en: 'Domain'
    },
    subdomain: {
      es: 'Subdominio',
      en: 'Subdomain'
    },
    operator: {
      es: 'Operador',
      en: 'Operator'
    },
    public: {
      es: 'Público',
      en: 'Public'
    },
    zone: {
      es: 'Zona',
      en: 'Zone'
    },
    area: {
      es: 'Área',
      en: 'Area'
    },
    table_desc: {
      es: 'Descripción de la tabla',
      en: 'Table description'
    },
    required: {
      es: 'Este campo es requerido',
      en: 'This field is required'
    },
    email_invalid: {
      es: 'El correo debe ser válido',
      en: 'E-mail must be valid'
    },
    files: {
      es: 'Archivos',
      en: 'Files'
    },
    attach: {
      es: 'Adjuntar',
      en: 'Attach'
    },
    filter: {
      es: 'Filtrar',
      en: 'Filter'
    },
    type_search: {
      es: 'Escribe para buscar',
      en: 'Type to search'
    },
    column: {
      es: 'Columna',
      en: 'Column'
    },
    data_element: {
      es: 'Nombre de elemento de datos',
      en: 'Data element name'
    },
    bdefinition: {
      es: 'Definición de negocio',
      en: 'Business definition'
    },
    transformation_logic: {
      es: 'Lógica de transformación',
      en: 'Transformation logic'
    },
    sensitive: {
      es: 'Sensible',
      en: 'Sensitive'
    },
    type: {
      es: 'Tipo',
      en: 'Type'
    },
    length: {
      es: 'Tamaño',
      en: 'Length'
    },
    valid_values: {
      es: 'Valores válidos',
      en: 'Valid values'
    },
    primary_key: {
      es: 'Llave primaria',
      en: 'Primary key'
    },
    null: {
      es: 'Nulo',
      en: 'Null'
    },
    encrypted: {
      es: 'Encriptado',
      en: 'Encrypted'
    },
    request_reason: {
      es: 'Razón de solicitud',
      en: 'Request reason'
    },
    leyenda_bterm: {
      es: '*Esta pestaña es independiente del flujo de trabajo. Puede grabar el término de negocio sin necesidad de que sea aprobado, siempre y cuando tenga el rol asignado para ello.',
      en: '*This tab is independent of the workflow. You can record the business term without having to be approved, as long as you have the role assigned for it.'
    },
    no_profiling: {
      es: 'No hay reglas definidas para esta tabla.',
      en: 'There are not defined rules for this table'
    },
    set_lineage_date: {
      es: 'Establecer rango de fechas para el linaje:',
      en: 'Set date range for lineage:'
    },
    from: {
      es: 'Del',
      en: 'From'
    },
    to: {
      es: 'Hasta',
      en: 'To'
    },
    connections: {
      es: 'Conexiones',
      en: 'Connections'
    },
    database: {
      es: 'Base de datos',
      en: 'Database'
    },
    description: {
      es: 'Descripción',
      en: 'Description'
    },
    project: {
      es: 'Proyecto',
      en: 'Project'
    },
    shared: {
      es: 'Compartido',
      en: 'Shared'
    },
    save_bterms: {
      es: 'Guardar términos de negocio',
      en: 'Save business terms'
    },
    response: {
      es: 'Respuesta',
      en: 'Response'
    },
    log_type: {
      es: 'Tipo de registro',
      en: 'Log type'
    },
    views: {
      es: 'Vistas',
      en: 'Views'
    },
    datasource: {
      es: 'Datasource',
      en: 'Datasource'
    },
    user_access: {
      es: 'Accesos de usuario',
      en: 'User access'
    },
    workspace: {
      es: 'Espacio de trabajo',
      en: 'Workspace'
    },
    app: {
      es: 'Aplicación',
      en: 'App'
    },
    save_tables: {
      es: 'Guardar tablas asignadas',
      en: 'Save assigned tables'
    },
    access_link: {
      es: 'Enlace del acceso',
      en: 'Access link'
    },
    private_access: {
      es: 'Acceso privado',
      en: 'Private access'
    },
    request: {
      es: 'Solicitud',
      en: 'Request'
    }
  },
  tablas: {
    nivel: 2,
    name: {
      es: 'Nombre',
      en: 'Name'
    },
    weight: {
      es: 'Peso',
      en: 'Weight'
    },
    table: {
      es: 'Tabla',
      en: 'Table'
    },
    columns: {
      es: 'Columnas',
      en: 'Columns'
    },
    rows: {
      es: 'Filas',
      en: 'Rows'
    },
    creation_date: {
      es: 'Fecha de creación',
      en: 'Creation date'
    },
    operator: {
      es: 'Operador',
      en: 'Operator'
    },
    datasource: {
      es: 'Datasource',
      en: 'Datasource'
    },
    dashboard: {
      es: 'Dashboard',
      en: 'Dashboard'
    },
    views: {
      es: 'Vistas',
      en: 'Views'
    },
    user: {
      es: 'Usuario',
      en: 'User'
    },
    groups: {
      es: 'Grupos',
      en: 'Groups'
    },
    user_inca: {
      es: 'Usuario INCA',
      en: 'INCA user'
    },
    applicant: {
      es: 'Solicitante',
      en: 'Applicant'
    },
    dataset: {
      es: 'Dataset',
      en: 'Dataset'
    },
    environment: {
      es: 'Entorno',
      en: 'Environment'
    },
    report: {
      es: 'Reporte',
      en: 'Report'
    },
    pages: {
      es: 'Páginas',
      en: 'Pages'
    },
    user_pbi: {
      es: 'Usuario PBI',
      en: 'PBI user'
    },
    end_date: {
      es: 'Fecha fin',
      en: 'End date'
    },
    bterm: {
      es: 'Término de negocio',
      en: 'Business term'
    },
    definition: {
      es: 'Definición',
      en: 'Definition'
    },
    object: {
      es: 'Objeto',
      en: 'Object'
    },
    owner: {
      es: 'Propietario',
      en: 'Owner'
    },
    sheet_type: {
      es: 'Tipo de hoja',
      en: 'Sheet type'
    },
    title: {
      es: 'Título',
      en: 'Title'
    },
    caption: {
      es: 'Subtítulo',
      en: 'Caption'
    },
    preview: {
      es: 'Previsualizar',
      en: 'Preview'
    },
    values: {
      es: 'Valores',
      en: 'Values'
    },
    total_tables: {
      es: 'Total de tablas',
      en: 'Total tables'
    },
    rol: {
      es: 'Rol',
      en: 'Role'
    },
    actions: {
      es: 'Acciones',
      en: 'Actions'
    }
  },
  validation_type: {
    es: 'Tipo de validación',
    en: 'Validation type'
  },
  assign: {
    es: 'Asignar',
    en: 'Assign'
  },
  sync: {
    es: 'Sincronizar',
    en: 'Sync'
  },
  assign_modal: {
    es: 'Asignar metadata en entorno prod/dev/test',
    en: 'Assign metadata in prod/dev/test environment'
  },
  search_table: {
    es: 'Buscar por tabla',
    en: 'Search by table'
  },
  search_project: {
    es: 'Buscar por proyecto',
    en: 'Search by project'
  },
  search_column: {
    es: 'Buscar por columna',
    en: 'Search by column'
  },
  search_operator: {
    es: 'Buscar por Operador',
    en: 'Search by Operator'
  },
  environment: {
    es: 'Entorno',
    en: 'Environment'
  },
  development: {
    es: 'Desarrollo',
    en: 'Development'
  },
  test: {
    es: 'Prueba',
    en: 'Test'
  },
  all: {
    es: 'Todos',
    en: 'All'
  },
  step1: {
    es: 'Paso 1',
    en: 'Step 1'
  },
  step2: {
    es: 'Paso 2',
    en: 'Step 2'
  },
  step3: {
    es: 'Paso 3',
    en: 'Step 3'
  },
  last_step: {
    es: 'Paso anterior',
    en: 'Last step'
  },
  tables: {
    es: 'Tablas',
    en: "Tables"
  },
  datasources: {
    es: 'Datasources de Tableau',
    en: "Tableau Datasources"
  },
  dashboards: {
    es: 'Dashboards de Tableau',
    en: "Tableau Dashboards"
  },
  bterms: {
    es: 'Términos de negocio',
    en: "Business Terms"
  },
  select_option: {
    es: 'Selecciona una opción',
    en: "Select an option"
  },
  download_template: {
    es: 'Descargar plantilla',
    en: "Download template"
  },
  upload_file: {
    es: 'Subir archivo',
    en: "Upload file"
  },
  details: {
    es: 'Detalles',
    en: "Details"
  },
  upload_csv: {
    es: 'Cargar CSV',
    en: "Upload CSV"
  },
  download_prod: {
    es: 'Descargar tablas productivas',
    en: "Download prod tables"
  },
  confirm_full: {
    es: 'Confirmar versión completa',
    en: "Confirm full version"
  },
  want_full: {
    es: '¿Quieres la versión completa?',
    en: "Do you want the full version?"
  },
  assign_operator: {
    es: 'Asignar operador',
    en: "Assign data operator"
  },
  project_id: {
    es: 'ID del proyecto',
    en: "Project ID"
  },
  dataset_id: {
    es: 'ID del dataset',
    en: "Dataset ID"
  },
  table_name: {
    es: 'Nombre de la tabla',
    en: "Table name"
  },
  add_tables_legend: {
    es: 'Agregar nuevas tablas sin metadatos a la plataforma INCA (solo si las tablas no existen en la opción Asignación de tablas).',
    en: "Add new tables without metadata to INCA platform (only if the tables does not exist in the Table assignments option)."
  },
  metadata: {
    es: 'Detalles de la metadata ',
    en: 'Table metadata details'
  },
  object_name: {
    es: 'Tipo de objeto',
    en: 'Object Type'
  },
  path_name: {
    es: 'Nombre de ruta',
    en: 'Path name'
  },
  dev_test: {
    es: 'Desarrollo/Prueba',
    en: 'Development/Test'
  },
  production: {
    es: 'Producción',
    en: 'Production'
  },
  request_reason: {
    es: 'Razón de solicitud',
    en: 'Request reason'
  },
  response_request: {
    es: 'Respuesta a la solicitud',
    en: 'Response reason'
  },
  view: {
    es: 'Ver',
    en: 'View'
  },
  email_details: {
    es: 'Ver correos',
    en: 'View emails'
  },
  new_email: {
    es: 'Asignar nuevo correo',
    en: 'Assign new email'
  },
  permission: {
    es: 'Ver permisos',
    en: 'View permission'
  },
  audit_logs: {
    es: 'Registros de auditoría',
    en: 'Audit logs'
  },
  download_csv: {
    es: 'Descargar CSV',
    en: 'Download CSV'
  },
  deactivate: {
    es: 'Desactivar',
    en: 'Deactivate'
  },
  activate: {
    es: 'Activar',
    en: 'Activate'
  },
  delete: {
    es: 'Eliminar',
    en: 'Delete'
  },
  no_objects: {
    es: 'No hay objetos para asignar',
    en: "No objects to assign"
  },
  no_objects_subtitle: {
    es: 'Cuando los haya podrás asignarlos aquí',
    en: 'When there are, you can assign them here'
  },
  user_tableau: {
    es: 'Usuario de Tableau',
    en: "Tableau user"
  },
  search_filters: {
    es: 'Filtros de Búsqueda',
    en: 'Search Filters'
  },
  text_filter: {
    es: 'Filtro de texto',
    en: 'Text filter'
  },
  update_metadata: {
    es: 'Actualizar metadata',
    en: 'Update metadata'
  },
  copy_id: {
    es: 'Copiar ID de vista',
    en: 'Copy View ID'
  },
  request_access: {
    es: 'Solicitar acceso',
    en: 'Request access'
  },
  set_temporal_do: {
    es: 'Establecer operador temporal',
    en: 'Set temporal data operator'
  },
  open_report_lds: {
    es: 'Abrir en Looker Studio',
    en: 'Open in Looker Studio'
  },
  bigquery: {
    es: 'Ver en BigQuery',
    en: 'See on BigQuery'
  },
  copy_view: {
    es: 'Copiar ID de la vista',
    en: 'Copy View ID'
  },
  manage_access: {
    es: 'Administrar acceso',
    en: 'Manage Access'
  },
  more_actions: {
    es: 'Más acciones',
    en: 'More actions'
  },
  assign_all_do: {
    es: 'Establecer operador temporal a todos los objetos',
    en: 'Assign all objects to temporal operator'
  },
  data_profiling: {
    es: 'Perfilado de datos ',
    en: 'Data profiling'
  },
  execute_profiling: {
    es: 'Ejecutar perfilamiento',
    en: 'Execute profiling'
  },
  choose_profiling: {
    es: 'Elegir regla de perfilamiento',
    en: 'Choose profiling rule'
  },
  access_table: {
    es: 'Tabla de acceso',
    en: 'Access table'
  },
  view_bterm: {
    es: 'Ver término',
    en: 'View Term'
  },
  data_operator: {
    es: 'Operador',
    en: 'Data operator'
  },
  viewer: {
    es: 'Espectador',
    en: 'Viewer'
  },
  menu: {
    nivel: 2,
    config: {
      es: 'Configuración',
      en: 'Setting'
    },
    rules: {
      es: 'Reglas',
      en: 'Rules'
    },
    profiling: {
      es: 'Perfilamiento',
      en: 'Profiling'
    },
    profiling_summary: {
      es: 'Resumen de Perfilamientos',
      en: 'Profiling Summary'
    },
    quality: {
      es: 'Calidad de Datos',
      en: 'Data Quality'
    },
    control_dashboard: {
      es: 'Dashboard Control',
      en: 'Control Dashboard'
    },
    executive_dashboard: {
      es: 'Dashboard Ejecutivo',
      en: 'Executive Dashboard'
    },
    dashboard_maintenance: {
      es: 'Mantenimiento de dashboard',
      en: 'Dashboard Maintenance'
    }
  }
};
export default labels;